import { render } from "./DatatableComponent.vue?vue&type=template&id=41496c05"
import script from "./DatatableComponent.vue?vue&type=script&lang=js"
export * from "./DatatableComponent.vue?vue&type=script&lang=js"

import "./DatatableComponent.vue?vue&type=style&index=0&id=41496c05&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__